export enum Technique {
  eq = "eq",
  compression = "compression",
  volume = "volume",
  pan = "pan",
  mixPuzzle = "mix_puzzle_technique",
}
